import React from "react";
import styles from "./MultipleValidity.module.scss";
import { t } from "i18next";
import { useSelector } from "react-redux";
import { newWebEngage } from "@src/utils/webEngageEvent";
import { formatCurrency } from "@src/utils/currencyFormatter";

import RightArrowIcon from "@src/components/AccentIcons/RightArrowIcon";

function MultipleValidity({ openModal, additionalClasses }) {
  const promotedValidityData = useSelector(
    (state) => state.overviewReducer.promotedValidity
  );

  const countryCode = useSelector(
    (state) =>
      state?.persistedDataReducer?.orgDetails?.organization?.countryCode
  );

  const handleEvent = () => {
    openModal();
    newWebEngage("multiple_course_validity_click");
  };
  return (
    <div className={`${styles.cardWrapper} ${additionalClasses}`}>
      <div className={styles.mainHeading}>
        {t(
          "components.tabs.overview.components.multipleValidity.index.courseValidity",
          "Course Validity"
        )}
      </div>
      <div className={styles.card} onClick={handleEvent}>
        <div className={styles.cardPriceWrapper}>
          <div className={styles.cardHeading}>
            {`${promotedValidityData.title} ${t(
              "components.tabs.overview.components.multipleValidity.index.for",
              "for"
            )} ${formatCurrency(countryCode, promotedValidityData.finalPrice)}`}
          </div>
          <div className={styles.cardSubheading}>
            {t(
              "components.tabs.overview.components.multipleValidity.index.changeCourseValidity",
              "Click to change course validity"
            )}
          </div>
        </div>
        <div>
          <div className={styles.viewAllButton}>
            {t(
              "components.tabs.overview.components.multipleValidity.index.viewAllText",
              "View All"
            )}
            <RightArrowIcon />
          </div>
        </div>
      </div>
    </div>
  );
}

export default MultipleValidity;
